import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import { Outlet, useLoaderData, useParams } from "react-router-dom";
import { useTenantNavigation } from "../../hooks/useTenantNavigation.js";
import type { LoaderFunction } from "react-router-dom";

import AppSidebar from "./sidebar";
import AppHeader from "./header";
import axios from "../../axios-interceptor.js";
import { SpaceContext } from "../../context";
import { useSelector } from "react-redux";
import { getUserSpaceEntitlements } from "../../utils/currentUserDetail";

const { Content, Footer } = Layout;

const layoutStyle = {
  minHeight: "100vh",
  // overflow:"hidden"
};

const contentStyle: React.CSSProperties = {
  minHeight: "120px",
  color: "#fff",

};

const footerStyle: React.CSSProperties = {
  textAlign: "center",
  backgroundColor: "#fff",
  borderTop: "1px solid rgba(0, 0, 0, 0.1)",
  display: "flex",
  justifyContent: "center"
};

interface Props {
  children?: React.ReactNode;
}

const pagesWithSidebar = ["organisation-structure", "workflow-configuration", "home-currency"]

const AppLayout: React.FC<Props> = () => {
  // let spaces = useLoaderData() as Array<{ spaceId: string; name: string, logoImage: string }>;
  let spaces: any[] = []
  const navigate = useTenantNavigation();
  const [toggleMargin, setToggleMargin] = useState(false)
  const { spaceId } = useParams();
  let showSidebar = false

  const { userInfo } = useSelector((state: any) => state.user)

  let userEmail = localStorage.getItem("userEmail") as string
  if (userInfo) {
    spaces = userInfo.spaceInfo || []
  }
  let pathname = window.location.pathname
  const hideHeader = new URLSearchParams(window.location.search).get("type") === "mobile"
  if (userInfo) {
    pagesWithSidebar.forEach(page => {
      if (pathname.includes(page)) {
        showSidebar = true
        // if(userEmail == "danish.raza@saltoris.com" || userEmail == "workflowmanager98@gmail.com" || userEmail=="adm10042024@gmail.com"){
        //   showSidebar = true
        // } 
      }
    })

  } else {
    //navigate("/login")
  }
  useEffect(() => {
    if (!userEmail) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const redirectUrl = urlParams.get("redirectFrom")
      if (redirectUrl && redirectUrl === "mail") {
        localStorage.setItem("redirectUrl", window.location.href)
      }
      navigate("/login")
    }
  }, [])
  // showSidebar = true

  return (
    <SpaceContext.Provider value={spaces} key={"pathname-" + pathname}>
      <Layout style={{ ...layoutStyle }} key={"sidebar - " + showSidebar}>
        {showSidebar && <AppSidebar spaces={spaces} userInfo={userInfo} updateParent={() => setToggleMargin(!toggleMargin)} spaceEntitlements={[]} />}

        <Layout style={{ marginLeft: toggleMargin ? 80 : 240, ...((!showSidebar) && { margin: "0 auto", width: "100%" }), transition: "0.3s margin" }}>
          {!hideHeader && <AppHeader showSidebar={showSidebar} />}
          <Content style={{ ...contentStyle, backgroundColor: (window.location.pathname.includes("settings") || window.location.pathname.includes("notification-center") || window.location.pathname.includes("user-role") || window.location.pathname.includes("configuration") || window.location.pathname.includes("controls")) ? "#F7F7F8" : "#fff" }} key={"current-path-" + window.location.pathname}>
            <Outlet />
          </Content>
          <Footer style={footerStyle}>
            <img src="/poweredBy.svg" alt="powered-by-saltoris" />
          </Footer>
        </Layout>
      </Layout>
    </SpaceContext.Provider>
  );
};

export default AppLayout;

export const appLoader: LoaderFunction = async ({ params }) => {
  let spaces = [], res;
  let userInfo = localStorage.getItem("v_userInfo") as any
  let spaceEntitlements = []

  if (userInfo) {
    userInfo = JSON.parse(userInfo)
  }
  try {
    res = await axios({
      method: "GET",
      // url: `${process.env.REACT_APP_BACKEND_API}/space`,
      url: `${process.env.REACT_APP_BACKEND_API}/userByEmail?email=${userInfo.email}`,
      params: {
        tenantId: localStorage.getItem("tenantId"),
      },
      headers: {
        "Content-Type": "application/json",
        userId: userInfo.userId,
      },
    });
    const userResult = res.data?.result || res.data || {};
    if (res.data && res.data && res.data.spaceInfo) {
      spaces = res.data.spaceInfo
    }
    if (userResult?.spaceInfo) {
      spaces = userResult.spaceInfo;
    }
    localStorage.setItem("v_userInfo", JSON.stringify({ ...userResult, email: userInfo.email }));
    const profileId = userResult?.userId || userResult?.id || "";
    if (profileId) {
      localStorage.setItem("userId", profileId);
      localStorage.setItem("id", profileId);
    }
  } catch (error) {
  }
  return spaces;
};
